// Pages/SoporteHC/hooks/useQueryHandler.js
import { useLazyQuery } from '@apollo/client/react';
import { useState } from 'react';

export const useQueryHandler = ({
    initialValues,
    query,
    onSuccess,
    onError,
    validations = {},
    handleChangeCallback = null,
    inputFields
}) => {
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [generalError, setGeneralError] = useState(null);

    const [executeQuery] = useLazyQuery(query);

    const handleChange = (name, value) => {
        setValues(prev => ({
            ...prev,
            [name]: value
        }));
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: null
            }));
        }
        if (handleChangeCallback) {
            handleChangeCallback();
        }
        setGeneralError(null);
    };

    const validateForm = () => {
        const newErrors = {};

        Object.entries(values).forEach(([key, value]) => {
            const fieldConfig = inputFields?.find(field => field.name === key);
            const fieldIsRequired = fieldConfig ? fieldConfig.required : true;

            if (validations[key]) {
                const error = validations[key](value);
                if (error) newErrors[key] = error;
            } else if (fieldIsRequired && (value === '' || value === null || value === undefined)) {
                newErrors[key] = `Este campo es requerido`;
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e, callbackOnSuccess) => {
        e.preventDefault();
        setLoading(true);
        setGeneralError(null);

        try {
            if (!validateForm()) {
                setLoading(false);
                return;
            }

            const { data, errors: graphqlErrors } = await executeQuery({
                variables: values
            });

            if (graphqlErrors && graphqlErrors.length > 0) {
                throw new Error(graphqlErrors[0].message);
            }

            if (callbackOnSuccess) {
                await callbackOnSuccess(data);
            }

            if (onSuccess) {
                onSuccess(data);
            }

        } catch (err) {
            const errorMessage = err.message || 'Error al procesar el formulario';
            setGeneralError(errorMessage);

            if (onError) {
                onError(err);
            }
        } finally {
            setLoading(false);
        }
    };

    const reset = () => {
        setValues(initialValues);
        setErrors({});
        setGeneralError(null);
    };

    const setValue = (name, value) => {
        setValues(prev => ({
            ...prev,
            [name]: value
        }));
    };

    return {
        values,
        errors,
        loading,
        generalError,
        handleChange,
        handleSubmit,
        reset,
        setValue,
        setValues
    };
};